define([
  "marionette",
  "messaging/messenger",
  "./taskScheduleView",
  "modules/tasks/tasksModel",
], function (Marionette, Messenger, TaskScheduleView, TaskModel) {
  "use strict";

  return Marionette.Controller.extend({
    initialize: function (options) {
      this.name = "taskSchedule";
      this.region = options.region;
    },
    show: function (task) {
      this.task = task;

      task.scheduledIntervals = Messenger.reqres.request("task:intervals:withoutNone");

      this.view = new TaskScheduleView.view({
        model: task,
      });
      this.view.on("change:task:is:scheduled", (isScheduled) => {
        task.set("scheduled", isScheduled);
        if (!isScheduled) {
          task.set("interval", TaskModel.INTERVAL.NONE);
        } else if (task.get("interval") == TaskModel.INTERVAL.NONE) {
          task.set("interval", TaskModel.INTERVAL.YEARLY);
          if (task.get("intervalAmount") < 1) {
            task.set("intervalAmount", TaskModel.DEFAULT_INTERVAL_AMOUNT);
          }
        }
        this.view.render();
      });
      this.view.on("change:task:schedule:interval", (intervalId) =>
        task.set("interval", intervalId),
      );
      this.view.on("change:task:schedule:intervalAmount", (intervalAmount) => {
        task.set("intervalAmount", intervalAmount);
        this.view.render();
      });
      this.view.on("change:task:has:expiration", (expire, expDate) => {
        if (!expire) {
          //set it to null so the DB knows that this scheduled task will not expire
          expDate = null;
        }
        task.set("hasExpiration", expire);
        task.set("expirationDate", expDate);
      });
      this.showRegion(this.view);
    },
    getExpirationDate: function () {
      if (!this.isScheduled()) {
        return null;
      }
      return this.view.getExpirationDate();
    },
    getInterval: function () {
      if (!this.isScheduled()) {
        return TaskModel.INTERVAL.NONE;
      }
      return this.view.getInterval();
    },
    getIntervalAmount: function () {
      if (!this.isScheduled()) {
        return TaskModel.DEFAULT_INTERVAL_AMOUNT;
      }
      return this.view.getIntervalAmount();
    },
    isScheduled: function () {
      return this.view.isScheduled();
    },
  });
});
